import FJConfig from '../FJConfig';

export const IMAGE_ENHANCER_POINT_COUNT = 4;
export const ZOOM_MIN = 0.2;
export const ZOOM_MIN_MOBILE = 1;
export const ZOOM_MAX = 5;
export const ZOOM_DOUBLE_RATE = 200;
export const MOBILE_IMAGE_MANIPULATION_PREVIEW_SRC =
    FJConfig.imgPath + 'mobileImageManipulation/' + 'image-manipulation-preview.mp4?v=' + FJConfig.version;
